module.exports = __webpack_public_path__ + "img/computer-invite-to-client-portal.1e3ce815.svg";